import createIcon from '@/lib/create-icon'

const HelpSearchIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 28 29'>
    <path
      d='M24.5001 25L20.0376 20.5375M13.4157 13.9085V13.667C13.4157 12.876 13.9045 12.4478 14.3945 12.1188C14.8728 11.7968 15.3524 11.3768 15.3524 10.6022C15.3524 9.53233 14.4855 8.66667 13.4168 8.66667C12.3482 8.66667 11.4802 9.53117 11.4802 10.601M13.2131 4C7.85727 4 3.5 8.23836 3.5 13.4494C3.5 18.6605 7.85727 22.9 13.2131 22.9C18.5677 22.9 22.925 18.6605 22.925 13.4494C22.925 8.23836 18.5677 4 13.2131 4Z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.4155 17.2417C13.3187 17.2417 13.2405 17.3198 13.2417 17.4167C13.2417 17.5135 13.3199 17.5917 13.4167 17.5917C13.5135 17.5917 13.5917 17.5135 13.5917 17.4167C13.5917 17.3198 13.5135 17.2417 13.4155 17.2417'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'HelpSearchIcon'
)

export default HelpSearchIcon
